<template>
<div id="localSwitcher">
<b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <img
                :src="icons[currentLocale]"
                class="country-icon as-toggle"
            /> {{names[currentLocale]}}
          </template>
      <b-dropdown-item @click="setLocaleItem(locale.code)" href="#"
      v-for="locale in locales" :key="locale.code">
         <img :src="icons[locale.code]" class="country-icon" />
         <span class="locale-name">{{locale.name}}</span>
            </b-dropdown-item>
        </b-nav-item-dropdown>
        </div>
</template>

<script>
import ruIcon from 'svg-country-flags/svg/ru.svg';
import kzIcon from 'svg-country-flags/svg/kz.svg';

import { locales } from '@/config/i18n';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      icons: {
        ru: ruIcon,
        kz: kzIcon,
      },
      names: {
        ru: 'Русский',
        kz: 'Казахский',
      },
      locales,
    };
  },
  methods: {
    ...mapActions('calc', ['setLocale']),
    setLocaleItem(item) {
      this.setLocale(item);
    },
  },

  computed: {
    currentLocale() {
      return this.$store.state.calc.currentLocale;
    },
    localeName() {
      return locales.filter((x) => (x.code === this.currentLocale));
    },
  },
};
</script>

<style>
    .country-icon {
        width: 20px;
        height: 14px;
        display: inline-block;
        vertical-align: baseline;
        border: 1px solid #dee2e6;
        box-shadow: 0px 1px 3px rgba(24, 29, 38, 0.1);
    }

    .country-icon.as-toggle {
        margin-top: 5px;
    }

    .locale-name {
        display: inline-block;
        vertical-align: baseline;
    }

@media (max-width: 979px) {
#localSwitcher.fishNavbar li a {
      color: #000 !important;
    }
   #localSwitcher.fishNavbar li a:hover {
      color: #000 !important;
    }
}

    #localSwitcher.fishNavbar li a {
      color: #fff;
    }
   #localSwitcher.fishNavbar li a:hover {
      color: #ffffff;
    }
    #localSwitcher a.dropdown-item{
      color:#000;
    }
    #localSwitcher a.dropdown-item:hover{
      color:#000;
    }

    .dropdown-menu a span {
      color: #000;
    }

    #localSwitcher ul{
      list-style: none;
    }
    #localSwitcher li {
      list-style: none;
    }

</style>
